import React from "react";
import { Button } from "@/components/ui/button";
import { LogOut, RefreshCw, Maximize2 } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

export const HeaderBar = ({ lastUpdated, onLogout, onRefresh, subtitle, onPresent, presentationDisabled = false }) => {
  let relative = "just now";
  try {
    if (lastUpdated) {
      relative = formatDistanceToNow(new Date(lastUpdated), { addSuffix: true });
    }
  } catch (e) {}

  return (
    <div className="showcase-header-band" data-testid="dashboard-header">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <p className="eyebrow" style={{ color: "#3F4F66" }}>
              LiftTech Portfolio
            </p>
            <h1
              className="font-heading text-3xl sm:text-4xl lg:text-5xl mt-1 leading-tight"
              style={{ color: "#1F1F1F", fontWeight: 600 }}
            >
              Where things stand today
            </h1>
            {subtitle && (
              <p className="text-sm sm:text-base text-muted-foreground mt-2 max-w-prose">
                {subtitle}
              </p>
            )}
          </div>
          <div className="flex flex-wrap items-center gap-3">
            {onPresent && (
              <Button onClick={onPresent} disabled={presentationDisabled} className="min-h-11 gap-2" data-testid="showcase-enter-presentation-mode-button">
                <Maximize2 size={16} aria-hidden="true" />Presentation mode
              </Button>
            )}
            <div
              className="text-xs text-muted-foreground text-right"
              data-testid="dashboard-last-updated"
            >
              <div className="eyebrow">Last update</div>
              <div className="text-sm text-foreground">{relative}</div>
            </div>
            {onRefresh && (
              <Button
                variant="outline"
                size="sm"
                onClick={onRefresh}
                data-testid="header-refresh-button"
                className="gap-1.5"
              >
                <RefreshCw size={14} strokeWidth={2.25} />
                <span className="hidden sm:inline">Refresh</span>
              </Button>
            )}
            {onLogout && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onLogout}
                data-testid="header-logout-button"
                className="gap-1.5"
              >
                <LogOut size={14} strokeWidth={2.25} />
                <span className="hidden sm:inline">Sign out</span>
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className="showcase-section-rule" />
    </div>
  );
};

export default HeaderBar;
